<template>
    <div>
        <v-dialog @keyup.esc="closeDialog" @click:outside="closeDialog" v-if="Object.keys($store.getters.homePageInformation.bookSupplier).length>0 && $store.getters.homePageInformation.bookSupplier.type === 'Library'"
                  v-model="$store.getters.orderDialog" max-width="1000">

            <v-card>

                <v-card-title class="mb-3 headline primary secondary--text">
                    <h5 class="pr-4">Βιβλίο:</h5>
                    <v-chip outlined color="secondary">{{book.title}}</v-chip>
                    <v-spacer/>
                    <v-icon color="secondary" @click="closeDialog">close</v-icon>
                </v-card-title>

                <v-card-text style="background-color: #E0F7FA">
                    <v-row >
                        <v-col cols="6">
                            <v-form v-model="valid">
                                <v-row class="pt-12">
                                    <v-col cols="12">
                                        <v-text-field class="text-black" color="black" style="font-size: 14px" :value="$store.getters.homePageInformation.bookSupplier.institutionName"
                                                      label="Ίδρυμα" dense outlined hide-details readonly/>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete class="text-black" color="black" style="font-size: 14px" v-model="orderForEdit.academicId" label="Τμήμα" :items="departments"
                                                  item-text="department" item-value="id" dense outlined hide-details :rules="[utils.requiredRule]"/>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete class="text-black" color="black" style="font-size: 14px" v-model="orderForEdit.libraryId" label="Βιβλιοθήκη" :items="libraries"
                                                  item-text="name" item-value="id" dense outlined hide-details :rules="[utils.requiredRule]"/>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="3">
                                        <v-text-field class="text-black" color="black" style="font-size: 14px" v-model="orderForEdit.amount"
                                                      label="Τεμάχια" dense outlined hide-details :rules="[utils.requiredRule, utils.wholeNumberRule]"/>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-text-field class="text-black" color="black" style="font-size: 14px" v-model="orderForEdit.bookId" @keypress="checkCharacter($event)"
                                                      label="Βιβλίο" dense outlined hide-details :rules="[utils.requiredRule]" type="number" hide-spin-buttons/>
                                    </v-col>
                                    <v-col cols="4" class="mx-0 px-0">
                                        <v-btn color="primary darken-2" outlined @click="getBook">Αναζήτηση<v-icon color="primary darken-2">search</v-icon></v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="3">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn :disabled="!valid || order.status === 'Expired'" outlined color="lightSeaGreen" @click="saveOrder"><v-icon color="lightSeaGreen">mdi-floppy</v-icon></v-btn>
                                                </span>
                                            </template>
                                            <span>Αποθήκευση</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn :disabled="order.status === 'Expired'" outlined color="primary darken-2" @click="resetOrder"><v-icon color="primary darken-2">mdi-reply</v-icon></v-btn>
                                                </span>
                                            </template>
                                            <span>Επαναφορά</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col v-if="order.status === 'Expired'" cols="3">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" outlined color="primary darken-2" @click="expireOrder">
                                                   <v-icon color="primary darken-2">mdi-cached</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Επανακαταχώριση</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn :disabled="orderIndex===null || order.status === 'Expired'" outlined color="indianRed" @click="deleteOrder"><v-icon color="indianRed">mdi-delete-forever</v-icon></v-btn>
                                                </span>
                                            </template>
                                            <span>Διαγραφή</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                        <v-col cols="6">
                            <v-row justify="center">
                                <v-col cols="12">
                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> Κωδικός Βιβλίου στον Εύδοξο </strong></v-list-item-title>
                                            <v-list-item-subtitle>{{book.id}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> Έκδοση</strong></v-list-item-title>
                                            <v-list-item-subtitle>{{book.editionNumber}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> Συγγραφείς </strong></v-list-item-title>
                                            <v-list-item-subtitle>{{book.authors}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> ISBN </strong></v-list-item-title>
                                            <v-list-item-subtitle>{{book.isbn}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> Τύπος</strong></v-list-item-title>
                                            <v-list-item-subtitle>{{returnBookType(book.type)}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-title ><strong> Τιμή</strong></v-list-item-title>
                                            <v-list-item-subtitle>{{book.price!=null?book.price:book.suggestedPrice!=null?book.suggestedPrice:0}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item >
                                        <v-list-item-content>
                                            <v-list-item-subtitle><a style="color: #0277BD" :href="'https://service.eudoxus.gr/search/#a/id:'+order.bookId+'/0'" target="_blank"><strong>περισσότερα</strong></a></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>

                            </v-row>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
	import requests from "../requests";
	import utils from "../utilities";

	export default {
		name: "OrderDialog.vue",
        props:{
			departments: Array,
			libraries: Array,
	        order: Object,
	        orderIndex: Number,
	        ordersCostBalance: Number,
        },
		data: () => ({
            valid:false,
            book:{
	            title:'',
	            id:'',
	            editionNumber:'',
	            authors:'',
	            isbn:'',
	            type:'',
	            price:'',
            },
            orderForEdit:{
	            academicId:'',
	            amount:'',
		        bookId:'',
                id:'',
                libraryId:'',
            },
		}),

		computed: {
			utils() {
				return utils;
			},
		},

		methods:{

			checkCharacter(event) {
				// Get the character code of the pressed key
				const charCode = event.charCode || event.keyCode;

				const charTyped = String.fromCharCode(charCode);

				if (!/^[0-9]$/.test(charTyped)) {
					event.preventDefault();
				}
			},

			saveOrder(){
                this.$store.commit('setLoadingModal', true);
                requests.put('rest/library-orders', this.orderForEdit, (resp) =>{
                    this.$emit('save-order', resp);
                    this.$store.commit('setLoadingModal', false);
					this.closeDialog();
                });
            },

			expireOrder(){
				this.$store.commit('setLoadingModal', true);
				requests.put('rest/library-orders/expireLibraryOrders', this.orderForEdit, (resp) =>{
					console.log(resp);
					this.$store.commit('setLoadingModal', false);
					this.closeDialog();
					}
				);
			},

			deleteOrder(){
				if(this.orderIndex!=null){
					this.$store.commit('setLoadingModal', true);
					requests.delete('rest/library-orders', this.order.id, () =>{
						this.$emit('delete-order', this.orderIndex);
						this.$store.commit('setLoadingModal', false);
					});
                }
            },

			getBook(){
				this.$store.commit('setLoadingModal', true);
				requests.get('rest/library-orders/book/' + this.orderForEdit.bookId, (resp) =>{
					this.book = JSON.parse(JSON.stringify(resp));
					this.$store.commit('setLoadingModal', false);
				});
			},

			returnBookType(type){
				if(type === 'Published') {
					return 'Σύγγραμμα'
				}
				else if(type === 'eBook') {
					return 'Ηλεκτρονικό Βιβλίο'
				}
				else if(type === 'ProfessorNotes') {
					return 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις'
				}
				else if(type === 'UniversityPress') {
					return 'Πανεπιστημιακή Έκδοση'
				}
				else if(type === 'Free') {
					return 'Δωρεάν Βιβλίο'
				}else {
					return '--';
				}
			},

            resetOrder(){
	            this.orderForEdit = JSON.parse(JSON.stringify(this.order));

	            if(Object.keys(this.order).length>0 ){
		            if(this.order.bookId!=null){
			            this.getBook();
		            }
	            }else{
		            this.book = {
			            title:'',
			            id:'',
			            editionNumber:'',
			            authors:'',
			            isbn:'',
			            type:'',
			            price:''
		            };
                }

            },

			closeDialog(){
				this.$store.commit('setOrderDialog', false);
			},
        },

        created() {
            if(Object.keys(this.order).length>0 ){
	            this.orderForEdit = JSON.parse(JSON.stringify(this.order));
	            if(this.order.bookId!=null){
		            this.getBook();
                }

            }
        }
	}
</script>

<style scoped>
    .v-text-field--outlined >>> fieldset {
        border-color: #000000;

    }

    .text-black >>> input {
        color: #000000 !important;
    }

    .text-black >>> label {
        color: #000000 !important;
    }
</style>